export enum EnRouteEventTypeEnum {
    COMMAND = 'COMMAND',
    CAMERA_COMMAND = 'CAMERA_COMMAND',
    MANUAL_CONTROL_COMMAND = 'MANUAL_CONTROL',
    WINCH_COMMAND = 'WINCH_COMMAND',
}